import TargetingProvider from '@/contexts/Targeting/TargetingProvider';
import AppAndSitesCategories from './AppAndSitesCategories';

import type { TargetingBaseType } from 'sonata-static-storage/lib/schemas/targeting/TargetingBaseType';
import type { UserInterface } from 'sonata-static-storage/lib/schemas/user/user.schema';
import type { UserRoleInterface } from 'sonata-static-storage/lib/schemas/user/userRole.schema';

type Props = {
  levelToExcludeV1?: string;
  levelToExcludeV2?: string;
  onChange: (targeting: TargetingBaseType) => void;
  targeting: TargetingBaseType;
  user: UserInterface;
  userRoles: UserRoleInterface[];
};

function AppAndSitesCategoriesWrapper({
  levelToExcludeV1,
  levelToExcludeV2,
  onChange,
  targeting,
  user,
  userRoles
}: Props) {
  return (
    <TargetingProvider onChange={onChange} targeting={targeting} user={user} userRoles={userRoles}>
      <AppAndSitesCategories levelToExcludeV1={levelToExcludeV1} levelToExcludeV2={levelToExcludeV2} />
    </TargetingProvider>
  );
}

export default AppAndSitesCategoriesWrapper;
